<script lang="ts">
  import Layout from "$app/Layouts/Plan.svelte"
  import { onMount } from "svelte"
  import { xhr, toast } from "$app/utils"
  import { Pulse } from "svelte-loading-spinners"
  import { ChevronRight, CalendarCheck2 } from "lucide-svelte"
  import FreePreview from "./FreePreview.svelte"
  import { appStore } from "$app/store.svelte"

  let props = $props()

  let meetings = $state([])
  let dates = $state()

  let isLoading = $state(true)
  async function initialize(): Promise<void> {
    isLoading = true
    try {
      const resp = await xhr.get(`/plans/${appStore.plan.id}/meetings.json`)

      let data = resp.data

      meetings = data.meetings
      dates = data.dates
    } catch (e) {
      console.error(e)
      toast("There was an error loading the meeting data", "error")
    } finally {
      isLoading = false
    }
  }

  onMount(async () => {
    initialize()
  })
</script>

<Layout {...props}>
  {#if appStore.subscription.subscription_type === "free"}
    <div class="py-6">
      <FreePreview />
    </div>
  {:else}
    <div class="max-w-4xl mx-auto py-6">
      <div class="flex items-center justify-center py-2">
        <CalendarCheck2 class="w-6 h-6 mr-2 text-gray-500" />
        <h1 class="text-2xl lg:text-3xl text-gray-600 font-bold">
          Transition Meetings
        </h1>
      </div>

      <div class="flex flex-col mt-6">
        <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
          <div
            class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
          >
            <div
              class="shadow overflow-hidden border-b border-gray-200 sm:rounded"
            >
              {#if isLoading}
                <div class="py-12 flex justify-center w-full">
                  <Pulse size="240" color="#cdcdcd" unit="px" duration="1s" />
                </div>
              {:else}
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-2/4"
                      >
                        Meeting Period
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4"
                      >
                        Status
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-1/4"
                      >
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    {#each meetings as meeting}
                      <tr class="bg-white">
                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                          >{meeting.title}</td
                        >
                        <td class="px-6 py-4 whitespace-nowrap">
                          {#if meeting.data}
                            {#if meeting.data.completed}
                              <div
                                class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-green-100 text-green-800 md:mt-2 lg:mt-0"
                              >
                                Completed
                              </div>
                            {:else if meeting.quarter >= dates.current_quarter && meeting.year >= dates.current_year && parseInt(meeting.data.current_step, 10) === 0}
                              <div
                                class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 md:mt-2 lg:mt-0"
                              >
                                Not Started
                              </div>
                            {:else if meeting.quarter >= dates.current_quarter && meeting.year >= dates.current_year && parseInt(meeting.data.current_step, 10) >= 1}
                              <div
                                class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 md:mt-2 lg:mt-0"
                              >
                                In Progress
                              </div>
                            {:else}
                              <div
                                class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-red-100 text-red-800 md:mt-2 lg:mt-0"
                              >
                                Incomplete
                              </div>
                            {/if}
                          {:else}
                            <div
                              class="inline-flex items-baseline px-2.5 py-0.5 rounded-full text-sm font-medium bg-yellow-100 text-yellow-800 md:mt-2 lg:mt-0"
                            >
                              Not Started
                            </div>
                          {/if}
                        </td>
                        <td
                          class="px-6 py-4 whitespace-nowrap text-sm font-medium"
                        >
                          <a
                            class="whitespace-nowrap text-blue-700 hover:bg-blue-800 hover:text-white border-blue-700 py-2 px-6 rounded border inline-flex items-center"
                            href="/plans/{appStore.plan
                              .id}/meetings?quarter={meeting.quarter}&year={meeting.year}"
                          >
                            Open Meeting
                            <ChevronRight class="w-8 h-8 pl-2" />
                          </a>
                        </td>
                      </tr>
                    {:else}
                      <tr>
                        <td
                          colspan="3"
                          class="px-6 py-4 text-center whitespace-nowrap font-medium text-gray-900"
                          >You have no transition meetings</td
                        >
                      </tr>
                    {/each}
                  </tbody>
                </table>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </div>
  {/if}
</Layout>
